import React, { useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import { server } from "../../common";
import { useDispatch } from "react-redux";

const initialValues = {
  org_contact: "",
  organization_name: "",
  business_email: "",
  org_password: "",
  otp: "",
  file: null,
  org_type: "",
};

const IndustryRegister = () => {
  document.title = "Register";
  const [step, setStep] = useState(0);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      org_contact: Yup.string()
        .matches(/^[6-9]\d{9}$/, "Please enter a valid Indian mobile number")
        .required("Please enter your contact number"),
      organization_name: Yup.string()
        .min(2, "Enter Organization Name")
        .required("Please Enter Your Organization Name"),
      // businessno: Yup.string()
      //   .min(2, "Enter Business contact")
      //   .required("Please Enter Your Business contact"),
      business_email: Yup.string()
        .min(2, "Enter Business Email")
        .required("Please Enter Your Business Email"),
      org_type: Yup.string()
        .min(2, "select organization type")
        .required("Please select organization type"),
      org_password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
        )
        .required("Please Enter Your password"),
    }),

    onSubmit: (values) => {
      server
        .post("/register/organizationregister", values, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          console.log("api response", response.data);
          if (response.status === 200 || response.status === 201) {
            if (response.data) {
              toast.success("User Register successfully");
              navigate("/loginorg");
              resetForm();
            }
          }
        })
        .catch(function (error) {
          if (error instanceof AxiosError && error.response?.data?.message)
            toast.error(error.response.data.message);
          else {
            toast.error(error.response.data.error);
          }
        });
    },
  });

  const sendOTPRequest = () => {
    const tst = toast.loading("Sending OTP", {
      theme: "colored",
      type: "info",
    });

    server
      .post("/otp/generate-otp", { email: values.business_email })
      .then((res) => {
        if (res.status === 200) {
          setOtpSent(true);
          toast.update(tst, {
            type: "success",
            render: res.data.message,
            isLoading: false,
            autoClose: 4000,
          });
        }
      })
      .catch((err) => {
        console.log(err.message);
        toast.update(tst, {
          type: "error",
          render: "Some Error Occurred",
          isLoading: false,
          autoClose: 4000,
        });
      });
  };

  const verifyOtp = (e) => {
    const tst = toast.loading("Verifying OTP", {
      theme: "colored",
      type: "info",
    });
    server
      .post("/otp/verify-otp", {
        email: values.business_email,
        otp: values.otp,
      })
      .then((res) => {
        if (res.status === 200) {
          setOtpVerified(true);
          setStep(2);
        }
        toast.update(tst, {
          type: "success",
          render: res.data.message,
          isLoading: false,
          autoClose: 4000,
        });
      })
      .catch((err) => {
        console.log(err.message);

        toast.update(tst, {
          type: "error",
          render: err.response.data.message,
          isLoading: false,
          autoClose: 4000,
        });

        // toast.error("Some Error Occured");
      });
  };

  const sendOTP = () => {
    // Assuming you want to send OTP only if the email is valid
    if (!errors.email) {
      sendOTPRequest();
    }
  };

  return (
    <>
      {console.log(values)}
      {console.log(errors)}

      <section className="" style={{ marginTop: "1rem" }}>
        <div className="container py-5 ">
          <div className="row d-flex justify-content-center align-items-center h-100">
            <div className="col col-xl-10">
              <div className="card" style={{ borderRadius: "1rem" }}>
                <div className="row g-0">
                  <div className="col-md-5">
                    <img
                      src="/images/r (2).jpg"
                      alt="login form"
                      className="img-fluid"
                      // height={800}
                      // width={450}
                      style={{ borderRadius: "1rem 0 0 1rem" }}
                    />
                  </div>
                  <div className="col-md-7 d-flex align-items-center">
                    <div className="card-body p-4 p-lg-5 text-black">
                      <div>
                        <h5
                          className="fw-normal mb-3 pb-3 text-center text-uppercase"
                          style={{ letterSpacing: 1 }}
                        >
                          Create your account
                        </h5>
                        <form onSubmit={handleSubmit}>
                          <div className="mb-2">
                            <TextField
                              name="organization_name"
                              margin="dense"
                              type="text"
                              placeholder="Enter Organization Name"
                              variant="outlined"
                              label="Organization Name"
                              value={values.organization_name}
                              onChange={handleChange}
                              fullWidth
                              required
                            ></TextField>
                            {errors.organization_name ? (
                              <p className="text-danger">
                                {errors.organization_name}
                              </p>
                            ) : null}
                          </div>

                          <div className="mb-2">
                            <FormControl fullWidth required className="mt-2">
                              <InputLabel id="demo-simple-select-label">
                                Type
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Year"
                                variant="outlined"
                                name="org_type"
                                value={values.org_type}
                                onChange={handleChange}
                                required
                              >
                                {/* <MenuItem value="city">City </MenuItem> */}
                                <MenuItem value="nonprofit">
                                  Nonprofit{" "}
                                </MenuItem>
                                <MenuItem value="government">
                                  Government
                                </MenuItem>
                                <MenuItem value="business">Business</MenuItem>
                                <MenuItem value="consultant">
                                  Consultant
                                </MenuItem>
                                <MenuItem value="recruiter">Recruiter</MenuItem>
                                <MenuItem value="community group/association">
                                  Association/Community Group
                                </MenuItem>
                              </Select>
                              {errors.org_type ? (
                                <p className="text-danger mb-0">
                                  {errors.org_type}
                                </p>
                              ) : null}
                            </FormControl>
                          </div>
                          <Row>
                            <Col md={10}>
                              <div className="mb-2">
                                <TextField
                                  name="business_email"
                                  margin="dense"
                                  type="email"
                                  placeholder="example@gmail.com"
                                  variant="outlined"
                                  label="Business Email"
                                  value={values.business_email}
                                  onChange={handleChange}
                                  fullWidth
                                  required
                                ></TextField>
                                {errors.business_email ? (
                                  <p className="text-danger">
                                    {errors.business_email}
                                  </p>
                                ) : null}
                              </div>
                            </Col>
                            <Col md={2}>
                              <button
                                // style={{ fontSize: "13px", width: "6rem" }}
                                className="mt-2 btn btn-primary text-white p-1 border-0 rounded-3 btn-sm"
                                type="submit"
                                onClick={(e) => {
                                  e.preventDefault();
                                  sendOTPRequest();
                                }}
                                disabled={otpSent} // Disable button if OTP has already been sent
                              >
                                {otpSent ? "Resend OTP" : "Send OTP"}
                              </button>
                            </Col>
                          </Row>
                          {otpSent && !otpVerified && (
                            <Row>
                              <Col md={9}>
                                <div className="mb-2">
                                  <TextField
                                    name="otp"
                                    margin="dense"
                                    type="text"
                                    placeholder="Enter OTP"
                                    variant="outlined"
                                    label="OTP"
                                    onChange={handleChange}
                                    fullWidth
                                    required
                                  />
                                </div>
                              </Col>
                              <Col md={2}>
                                <button
                                  className="mt-3 btn btn-success text-white border-0 rounded-3 align-self-center"
                                  type="submit"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    verifyOtp(true);
                                  }}
                                >
                                  Verify
                                </button>
                              </Col>
                            </Row>
                          )}

                          <div className="mb-2">
                            <TextField
                              name="org_contact"
                              margin="dense"
                              type="text"
                              placeholder="Business Contact Number"
                              variant="outlined"
                              label="Business Contact Number"
                              value={values.org_contact}
                              onChange={handleChange}
                              fullWidth
                              required
                            ></TextField>
                            {errors.org_contact ? (
                              <p className="text-danger">
                                {errors.org_contact}
                              </p>
                            ) : null}
                          </div>
                          {otpVerified && (
                            <div className="mb-2">
                              <TextField
                                name="org_password"
                                margin="dense"
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                variant="outlined"
                                label="Password"
                                value={values.org_password}
                                onChange={handleChange}
                                fullWidth
                                required
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={handleTogglePassword}
                                        edge="end"
                                      >
                                        {showPassword ? (
                                          <i className="far fa-eye-slash"></i>
                                        ) : (
                                          <i className="far fa-eye"></i>
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                              {errors.org_password ? (
                                <p className="text-danger">
                                  {errors.org_password}
                                </p>
                              ) : null}
                            </div>
                          )}

                          <div className="text-center">
                            <button
                              className="banner border-0 p-2 mt-2 w-100 rounded-5 text-white "
                              type="submit"
                            >
                              Register
                            </button>
                            <p className="mt-2">
                              I already have an account ?
                              <NavLink to="/loginorg"> Login</NavLink>
                            </p>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default IndustryRegister;
